import { Box, NavTab } from '@csp/csp-web-ui';
import { FC } from 'react';
import { CspPath } from '../../../CspPath';
import { StaticContentService } from '../../../common/service/StaticContentService';
import { HeaderNavTabsComponent } from '../component/HeaderNavTabsComponent';
import { useSelectedNavTab } from '../hooks/useSelectedNavTab';
import { HeaderConstants } from '../model/HeaderConstants';
import { useStudyContext } from '../../../common/context/study/useStudyContext';
import { useCanViewStudyDocuments } from '../../study-documents/hook/useCanViewStudyDocuments';
import { useCanViewStudyArchiving } from '../../study-archiving/hook/useCanViewStudyArchiving';

export const StudyOverviewNavSubTabsContainer: FC = () => {
  const navigationTabsTexts = StaticContentService.getGenericBlock('webHcpStudyOverview', 'navigationTabs');
  const { studyConfig } = useStudyContext();

  const canViewStudyDocuments = useCanViewStudyDocuments();
  const canViewStudyArchiving = useCanViewStudyArchiving();

  const mainNavTabs: NavTab<CspPath>[] = [
    {
      label: navigationTabsTexts.button.overview.label,
      path: CspPath.STUDY_OVERVIEW_OVERVIEW,
      isEnabledFeature: true,
    },
    {
      label: navigationTabsTexts.button.documents.label,
      path: CspPath.STUDY_OVERVIEW_DOCUMENTS,
      isEnabledFeature: canViewStudyDocuments,
    },
    {
      label: navigationTabsTexts.button.archiving.label,
      path: CspPath.STUDY_OVERVIEW_ARCHIVING,
      isEnabledFeature: studyConfig.studyArchivingConfig.enabled && canViewStudyArchiving,
    },
  ].filter(i => i.isEnabledFeature);

  const selectedTab = useSelectedNavTab(mainNavTabs, CspPath.STUDY_OVERVIEW_OVERVIEW);

  return (
    <>
      <Box height={`${HeaderConstants.NAV_TABS_GAP_HEIGHT}rem`} bgcolor="transparent.grey" />
      <HeaderNavTabsComponent isSubTab tabs={mainNavTabs} selectedPath={selectedTab} />
    </>
  );
};
